import GtagTracker from './gtag'

export default class GoogleAnalyticsTracker extends GtagTracker {
  // eslint-disable-next-line no-useless-constructor
  constructor(gtag, id) {
    super(gtag, id)
  }

  sendPageViewEvent(route, pageTitle, pageLocation, pagePath) {
    this._gtag('config', this._id, {
      dimension1: this._version,
      page_location: pageLocation,
      page_path: pagePath,
      page_title: pageTitle,
      user_id: this._userId,
    })
  }

  setUserId(userId) {
    this._userId = userId
  }

  setAppVersion(version) {
    this._version = version
  }
}
